
<template>
  <div class="cookie-consent" id="cookie_constent_div">
    <div class="msg">
      <span style="font-size: 3em; right: 1rem; color: #f0f8ff; position: relative;">
        <i class="fas fa-info-circle" style="color: white;"></i>
      </span>
      <div class="cookie-terms">
        Unsere Website verwendet Cookies und ähnliche Technologien, um Ihnen einen
        besseren
        Service bei der Suche und der Bestellung zu bieten, zu Analysezwecken und um die Ihnen angezeigte
        Werbung zu
        personalisieren.
        <div class="cookie-term-link">
          Sie können Ihre Cookie-Einstellungen durch das Lesen unserer
          <a
            href="https://de.rs-online.com/web/generalDisplay.html?id=aboutRS&file=cookiePolicy"
            target="_blank"
            title="Cookie-Richtlinien"
          >Cookie-Richtlinien</a> ändern. Andernfalls werden wir davon ausgehen,
          dass Sie mit unserer Verwendung von Cookies einverstanden sind.
        </div>
      </div>
      <div class="cookie-accept" id="js-cookie-accept" @click="setCookie()">
        <span style="top: 0.16rem; position: relative;">
          <i class="far fa-check-circle"></i> OK, ich verstehe
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppCookiePolicy",
  data() {
    return {
      cookie_set: ""
    };
  },
  methods: {
    setCookie() {
      this.$cookie.set("accept_cookies", "true", { expires: "6M" });
      document.querySelector(".cookie-consent").style.display = "none";
    },
    checkCookie() {
      let cookie = this.$cookie.get("accept_cookies");
      cookie &&
        (document.getElementById("cookie_constent_div").style.display = "none");
    }
  },
  mounted() {
    this.checkCookie();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:link,
a:visited {
  color: #333;
}
a:hover {
  color: #c00;
}

.cookie-consent .cookie-accept .icon-accept:before {
  content: "\E9B0";
}
.cookie-consent .icon-info:before {
  content: "\E9B1";
}
.cookie-consent {
  font-size: 12px;
  padding: 10px 10px 10px 0;
  color: #fff;
  background-color: #333;
  position: fixed;
  overflow: hidden;
  display: flex;
  left: 0;
  right: 0;
  top: 0;
}
.cookie-consent .msg {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  /* display: block; */
  box-sizing: border-box;
  width: 1200px;
  margin: auto;
  padding: 20px 40px 20px 80px;
}
.cookie-consent .icon-info {
  display: inline-block;
  width: 5px;
  vertical-align: top;
}
.cookie-consent .icon-info:before {
  font-size: 45px;
  position: relative;
  left: -45px;
}
.cookie-consent .cookie-terms {
  display: inline-block;
  width: 700px;
  color: white;
  font-weight: bold;
  padding-left: 20px;
  vertical-align: top;
  border-left: 1px solid white;
}
.cookie-consent .cookie-term-link {
  padding-top: 10px;
}
.cookie-consent .cookie-term-link a,
.cookie-consent .cookie-term-link a:link,
.cookie-consent .cookie-term-link a:visited,
.cookie-consent .cookie-term-link a:hover,
.cookie-consent .cookie-term-link a:active {
  color: #fff;
  text-decoration: underline;
}
.cookie-consent .cookie-accept {
  position: relative;
  top: 24px;
  display: inline-block;
  flex-wrap: wrap;
  font-weight: bold;
  margin: 0 auto;
  float: right;
  width: 170px;
  padding: 5px 10px 5px 10px;
  text-align: center;
  background-color: red;
  border-radius: 5px 5px 5px 5px;
  box-sizing: content-box;
  height: 26px;
}
.cookie-consent .cookie-accept:hover {
  cursor: pointer;
}
.cookie-consent .cookie-accept .icon-accept:before {
  font-size: 23px;
  vertical-align: middle;
  left: -10px;
  position: relative;
}

body #cookie_constent_div .cookie-terms {
  font-weight: normal;
}

body .cookie-consent .msg,
body #cookie_constent_div {
  width: 100% !important;
}

body #cookie_constent_div {
  z-index: 334;
}

body .cookie-accept {
  margin-bottom: 10px !important;
}

@media (max-width: 900px) and (orientation: landscape),
  screen and (max-width: 767px) {
  body #cookie_constent_div {
    top: unset;
    bottom: 0;
  }

  body #cookie_constent_div .fa-info-circle {
    display: none;
  }

  body #cookie_constent_div .cookie-terms {
    width: 100%;
    border-left: 0;
    padding: 10px;
    padding-bottom: 0;
    font-size: 0.6em !important;
  }

  body #app .cookie-consent .msg {
    padding: 10px;
    padding-bottom: 30px;
  }
}

@media (max-width: 567px) {
  body #cookie_constent_div .cookie-terms {
    font-size: 0.92em !important;
  }
}

@media (max-width: 641px) {
  /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
  .cookie-consent .cookie-terms {
    display: inline-block;
    width: 12rem;
    padding-left: 20px;
    vertical-align: top;
    border-left: 1px solid white;
  }
}
</style>